import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { dateFormat } from '../helpers'
import React from 'react'
import { Button } from '@material-ui/core'
import moment from 'moment'

const Forecast = props => {
  const editCondition =
    props.forecast.editable && (
      moment(props.forecast.forecastDate).isSame(moment().add(1, 'days'), 'day')
      ||
      (
        moment(props.forecast.forecastDate)
        .startOf('day')
        .isSame(moment().startOf('day'))
        &&
        moment().isBefore({ hours: 10 })
      )
    )
  return (
    <div className={props.classes.entry}>
      <div className={props.classes.entryInfo}>
        <Grid container>
          <Grid item xs={4}>
            <Typography className={props.classes.entryText}>Fecha de entrada prevista</Typography>
            <Typography className={props.classes.entryTextBold} style={{ fontSize: 17 }}>
              {dateFormat(props.forecast.forecastDate)}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={props.classes.entryText}>Producto</Typography>
            <Typography className={props.classes.entryTextBold}>{props.forecast.productName}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={props.classes.entryText}>Agricultor</Typography>
            <Typography className={props.classes.entryTextBold}>{props.forecast.farmerName}</Typography>
          </Grid>
        </Grid>
      </div>
      <div className={props.classes.entryNumbers}>
        <Grid container className={props.classes.entryGridContainer}>
          <Grid item xs={12}>
            <Typography className={props.classes.entryNumber}>
              <span className={props.classes.entryNumberUnit}>Total: </span>
              <br />
              {props.forecast.totalKg}
              <span className={props.classes.entryNumberUnit}> kg.</span>
            </Typography>
          </Grid>
          {editCondition ? (
            <Button
              className={props.classes.entryEditButton}
              variant="raised"
              onClick={() => {
                const kgString = '' + props.forecast.totalKg
                props.onCreateForecast({
                  farmerName: props.forecast.farmerName,
                  kgString,
                  id: props.forecast.id,
                  date: moment(props.forecast.forecastDate)
                    .format('DD-MM-YYYY')
                    .toLocaleString(),
                  productTypeId: props.forecast.productTypeId,
                })
              }}>
              Editar
            </Button>
          ) : null}
        </Grid>
      </div>
    </div>
  )
}

const styles = {
  entry: {
    margin: '15px 15px',
    background: 'white',
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.17)',
    borderRadius: 4,
  },
  entryInfo: {
    padding: 10,
  },
  entryText: {
    fontSize: 12,
    fontWeight: 300,
    lineHeight: '16px',
  },
  entryTextBold: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '14px',
  },
  entryNumbers: {
    padding: '8px 0 3px',
    background: '#8ACA4C',
  },
  entryNumber: {
    fontSize: 25,
    fontWeight: 500,
    color: 'white',
    textAlign: 'center',
    lineHeight: '22px',
  },
  entryNumberUnit: {
    marginLeft: 3,
    fontSize: 12,
    fontWeight: 400,
  },
  entryClasification: {
    marginTop: 1,
    padding: '8px 0 3px',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  entryClasificationStatus: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
  },
  entryGridContainer: {
    position: 'relative',
  },
  entryEditButton: {
    position: 'absolute',
    right: 5,
    marginTop: 13,
  },
  pending: {
    background: '#999999',
  },
  sampled: {
    background: '#E3A439',
  },
  invoiced: {
    background: '#8ACA4C',
  },
  goToClasification: {
    background: 'white',
    color: '#000',
    fontSize: 13,
    borderRadius: 4,
    padding: '2px 1px 3px 5px',
  },
  goToClasificationIcon: {
    fontSize: 17,
    fontWeight: 300,
  },
}

export default withStyles(styles)(Forecast)



// WEBPACK FOOTER //
// ./src/components/Forecast.js